import { modelServices } from '@/app/shared/services/client-agent-service.js';

export function guardRoute(to, from, next) { 
    // In Case we need the user to access  a page without any authentications or security 
    if (!modelServices.isAuthenticated()
        &&
        (to.path == "/queuing-management/setups/waiting-area-screen" || to.path == "/queuing-management/setups/monitor-screen")
    ) {
        // console.log('monitor') 
        next(true);
    }
    else if(from.path == "/queuing-management/setups/waiting-area-screen"  || from.path == "/queuing-management/setups/monitor-screen"){
        console.log('guard route if else ')
        // next(true);

    }
    else if (to.path == "/") {
        if (modelServices.isAuthenticated()) {
            next("/dashboard");
        }
        else {

                next();
        }
    }
    else { 
        if (modelServices.isAuthenticated()) {
            next();

            //if (to.meta.requiresAuth && to.matched.some(record => record.meta.requiresAuth)) {
            //    to.meta.requiresAuth.forEach((ele) => {
            //        if (modelServices.ifUserHasPermission(ele, to.path)) {
            //            next();
            //        }
            //        else {
            //            next("/401");
            //        }
            //    });
            //}
            //else {
            //    next();
            //}
        }
        else {
         
                next('/');
        }
    }
}